module.exports = __webpack_public_path__ + "assets/img/my-vpp-bg-ny.27bcc7e1.png";